import { tokenPrefix, tokenVar } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

interface GridColourOptionsI {
  backgroundColour: string
  colorScheme?: ColorScheme
  iconColour: string
  tone: 'error' | 'success'
}

export const getGridColours = ({
  backgroundColour,
  colorScheme,
  iconColour,
  tone,
}: GridColourOptionsI) => {
  if (!colorScheme) {
    return {
      background: backgroundColour,
      descriptionText: '#22272B',
      icon: iconColour,
      primaryText: '#22272B',
      secondaryText: '#454F59',
      title: iconColour,
    }
  }

  const prefix = tokenPrefix(colorScheme)
  const primaryText = tokenVar(`colors.${prefix}text.primary`)
  const statusText = tokenVar(`colors.${prefix}status.${tone}-text`)
  const secondaryText = colorScheme === 'light' ? primaryText : statusText
  const iconToken = tone === 'success' ? 'success-icon' : 'error'

  return {
    background: tokenVar(`colors.${prefix}status.${tone}-bg`),
    descriptionText: secondaryText,
    icon: tokenVar(`colors.${prefix}status.${iconToken}`),
    primaryText,
    secondaryText,
    title: primaryText,
  }
}
